import { useFeatureFlagEnabled } from 'posthog-js/react'

import type { FeatureFlag } from '@/types/feature-flag'

export const useFeatureFlag = (featureName: FeatureFlag) => {
  const featureFlagFromPosthog = useFeatureFlagEnabled(featureName)

  // e2e tests are not currently being developed so disabled feature flags now
  if (import.meta.env.VITE_SCHOOL_ID === 'e2e') return false

  return (
    (process.env.NODE_ENV === 'development' &&
      !import.meta.env.VITE_POSTHOG_KEY) ||
    featureFlagFromPosthog
  )
}
